var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "page-main",
    class: [_vm.$store.state.folding ? 'folded' : '']
  }, [(_vm.template === 'default') ? [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "page-main-content"
  }, [_c('div', {
    staticClass: "slide-menu-wrap"
  }, [_c('main-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "page-right-content"
  }, [_c('div', {
    staticClass: "main-view"
  }, [_c('router-view', {
    class: ['main-container', _vm.classScoped]
  })], 1), _vm._v(" "), _c('main-footer', {
    staticClass: "hide"
  })], 1)])] : (_vm.template === 'full') ? [_c('router-view', {
    class: [_vm.classScoped]
  })] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f16a5e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = null
// module chunks = 